var render = function (_h,_vm) {var _c=_vm._c;return _c(_vm.props.to ? 'router-link' : _vm.props.href ? 'a' : 'button',_vm._b({ref:_vm.data.ref,tag:"button",staticClass:"base-button",class:(Array.isArray(_vm.data.class) ? _vm.data.class : [_vm.data.class]).concat( [_vm.data.staticClass],
    [{
      '_full-width': _vm.props.fullWidth,
      '__secondary': _vm.props.secondary,
      '__gradient': _vm.props.gradient,
      '__outline': _vm.props.outline,
      '__outline-negative': _vm.props.outlineNegative,
      '__gray': _vm.props.gray,
      '__green': _vm.props.green,
      '__red': _vm.props.red,
      '__white': _vm.props.white,
      '__small': _vm.props.small,
      '__small-xs': _vm.props.smallXs,
      '__round': _vm.props.round,
      '__disabled': _vm.props.disabled,
      '__transparent': _vm.props.transparent,
      '__text-like': _vm.props.textLike,
    }] ),style:((Array.isArray(_vm.data.style) ? _vm.data.style : [_vm.data.style]).concat( [_vm.data.staticStyle])),attrs:{"disabled":_vm.props.disabled,"target":(_vm.props.to || _vm.props.href) && _vm.props.target},on:{"click":function (e) {
      if (_vm.props.disabled || _vm.props.loading) { return; }
      _vm.listeners.click && _vm.listeners.click(e);
    }}},'button',_vm.props,false),[(!_vm.props.loading)?_vm._t("default"):_c('base-spinner',{attrs:{"size":_vm.props.small || _vm.props.smallXs ? '20px' : '35px',"color":_vm.props.spinnerColor
        ? _vm.props.spinnerColor
        : _vm.props.secondary || _vm.props.outline
        ? 'var(--palette-negative)'
        : _vm.props.gray
        ? ''
        : 'var(--palette-bg)'}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }